import { atom } from 'jotai'

export const activeBookIdAtom = atom(null)
export const activeQuestionAtom = atom(null)
export const activeAnswerAtom = atom(null)
export const activeAnswerImagesAtom = atom([])
export const showAnswerEditModalAtom = atom(false)
export const showPromptFreqModalAtom = atom(false)
export const showAnswerPreviewModalAtom = atom(false)
export const bookIdAtom = atom(null)
